import React from 'react'
import { useTranslation } from 'react-i18next'
import { LockKeyhole } from 'lucide-react'
import { tr } from 'i18n'
import './ActorPinField.scss'

type Props = { value: string; disabled?: boolean; onChange: (value: string) => void; hint?: string }

export default function ActorPinField({ value, disabled, onChange, hint = 'Введите PIN своей учётной записи. PIN водителя не подходит.' }: Props) {
  useTranslation()
  return <label className="actor-pin-field">
    <span><LockKeyhole size={16} aria-hidden="true" />{tr('Ваш PIN')}</span>
    <input type="password" name="actor_pin" aria-label={tr('Ваш PIN')} inputMode="numeric" autoComplete="off"
      required pattern="[0-9]{4}" maxLength={4} value={value} disabled={disabled}
      onChange={event => onChange(event.target.value.replace(/[^0-9]/g, '').slice(0, 4))} />
    <small>{tr(hint)}</small>
  </label>
}
